<div class="container-fluid print-panel">
  <div class="zoom-panel">
    <a class="btn main-tools-btn shadow" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip"
      data-bs-placement="left" data-bs-html="true" title="ฟิตขนาดจอ" (click)="resetZoom()">
      <i class="bi bi-arrows-angle-contract"></i>
    </a>
    <a class="btn main-tools-btn shadow" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip"
      data-bs-placement="left" data-bs-html="true" title="ขยายเข้า" (click)="zoomIn()">
      <i class="bi bi-plus"></i>
    </a>
    <a class="btn main-tools-btn shadow" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip"
      data-bs-placement="left" data-bs-html="true" title="ขยายออก" (click)="zoomOut()">
      <i class="bi bi-dash"></i>
    </a>
  </div>

  <div class="row" style="height: calc(100vh - 78px); overflow: hidden">
    <div class="col-12 col-lg-9 py-3" style="
        background-color: gray;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: auto;
        height: calc(100vh - 78px);
      " id="paperEditor" #paperEditor>
      <div #paperContainer class="paper-container" [ngStyle]="{
          width: getPaperWidth(),
          height: getPaperHeight(),
        }">
        <div class="image-container" [ngStyle]="{
          width: getPaperWidth(),
          height: getPaperHeight(),
        }">
          <ng-container *ngIf="mapImage">
            <div class="d-flex justify-content-center align-items-center" [ngStyle]="{
                width: getPaperWidth(),
                height: getPaperHeight(),
              }">
              <img [src]="currentMapsImage" draggable="false" class="map-source-image" alt="Captured Map Image"
                [ngStyle]="{
                  width:  getPaperWidth(),
                  maxWidth: getPaperWidth(),
                }" [style.opacity]="data.opacity + '%'" />
            </div>
          </ng-container>

          <div *ngFor="let textbox of textboxes" [id]="textbox.id" class="text-container-wrapper no-panzoom"
            [attr.data-x]="textbox.dataX" [attr.data-y]="textbox.dataY" [attr.data-elementid]="textbox.id" [ngStyle]="{
              transform:
                'translate(' + textbox.dataX + 'px, ' + textbox.dataY + 'px)'
            }" (dblclick)="textbox.isEditable && enableEditing(textbox.id)"
            (contextmenu)="onRightClick($event, $any($event).target, textbox)">
            <div [ngClass]="{ 'd-none': textbox.isEditing }" [id]="textbox.id + '-preview'"
              [attr.data-elementid]="textbox.id" class="text-preview-printmaps"
              [innerHTML]="sanitizeHtml(textbox.content)"></div>

            <textarea [ngClass]="{ 'd-none': !textbox.isEditing }" type="text" *ngIf="textbox.isEditable"
              class="text-input-printmaps" [id]="textbox.id + '-text-input'" [attr.data-elementid]="textbox.id"
              [(ngModel)]="textbox.content" (blur)="disableEditing(textbox.id)"></textarea>
          </div>

          <!-- Draggable and resizable images -->
          <div *ngFor="let image of images" [id]="image.id" [attr.data-elementid]="image.id"
            class="draggable-resizable-container no-panzoom" [ngStyle]="{
              maxWidth: getPaperWidth(),
              maxHeight: getPaperHeight(),
            }" (contextmenu)="onRightClick($event, $any($event).target, image)">
            <!-- Image -->
            <img id="{{ image.id }}-el" [attr.data-elementid]="image.id" [src]="image.src" class="draggable-image" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-3 mt-3">
      <div style="max-height: calc(100vh - 78px); overflow: auto">
        <a [routerLink]="['/maps']" class="">
          <i class="bi bi-arrow-left"></i>
          กลับสู่แผนที่
        </a>

        <div>
          <h3 class="my-2">แนวกระดาษ</h3>

          <div class="d-flex">
            <input type="radio" class="btn-check" id="paperLayoutType1" name="paperLayoutType"
              [(ngModel)]="data.paperLayoutType"
              (ngModelChange)="resetZoom(); toggleWatermark(); resetContentPosition();" value="portrait"
              autocomplete="off" checked />
            <label class="btn btn-print-custom w-100 me-2" for="paperLayoutType1">แนวตั้ง</label>

            <input type="radio" class="btn-check" id="paperLayoutType2" name="paperLayoutType"
              [(ngModel)]="data.paperLayoutType"
              (ngModelChange)="resetZoom(); toggleWatermark(); resetContentPosition();" value="landscape"
              autocomplete="off" />
            <label class="btn btn-print-custom w-100 me-2" for="paperLayoutType2">แนวนอน</label>
          </div>
        </div>

        <div>
          <h3 class="my-2">ขนาดกระดาษ</h3>

          <div class="d-flex">
            <input type="radio" class="btn-check" name="paperType" [(ngModel)]="data.paperType"
              (ngModelChange)="resetZoom(); resetContentPosition();" id="paperType1" value="a3" autocomplete="off"
              checked />
            <label class="btn btn-print-custom w-100 me-2" for="paperType1">A3</label>

            <input type="radio" class="btn-check" name="paperType" [(ngModel)]="data.paperType"
              (ngModelChange)="resetZoom(); resetContentPosition();" id="paperType2" value="a4" autocomplete="off" />
            <label class="btn btn-print-custom w-100 me-2" for="paperType2">A4</label>

            <input type="radio" class="btn-check" name="paperType" [(ngModel)]="data.paperType"
              (ngModelChange)="resetZoom(); resetContentPosition();" id="paperType3" value="a0" autocomplete="off" />
            <label class="btn btn-print-custom w-100 me-2" for="paperType3">A0</label>
          </div>
        </div>

        <div>
          <h3 class="my-2">ระดับความละเอียด</h3>

          <select [(ngModel)]="data.dpiType" class="form-select form-select-sm">
            <option [value]="72">72 dpi</option>
            <option [value]="96">96 dpi</option>
            <option [value]="150">150 dpi</option>
            <option [value]="300">300 dpi (แนะนำ)</option>
            <option [value]="600">600 dpi</option>
            <option [value]="1200">1200 dpi</option>
          </select>
        </div>
        <div>
          <h3 class="my-2">องค์ประกอบแผนที่</h3>

          <!-- <div class="d-flex align-items-center">
            <p class="mx-3" style="width: 50px">1 :</p>
            <div class="position-relative mb-3 w-100">
              <label for="" class="form-label">มาตราส่วน</label>
              <input type="text" class="form-control me-2" [value]="formattedMapScale" readonly />
            </div>
          </div> -->

          <div class="d-flex justify-content-between">
            <div>
              <div class="form-check form-check-inline mb-2">
                <input class="form-check-input me-2" type="checkbox" id="miscChkBox1" [(ngModel)]="data.isUseScaleBar"
                  (change)="changeMapImageType()" style="width: 20px; height: 20px" checked />
                <label class="form-check-label pt-1" for="miscChkBox1">สเกลบาร์</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input me-2" type="checkbox" id="miscChkBox2" [(ngModel)]="data.isUseGrid"
                  (change)="changeMapImageType()" style="width: 20px; height: 20px" />
                <label class="form-check-label pt-1" for="miscChkBox2">กริด</label>
              </div>
            </div>
          </div>
        </div>



        <div class="d-flex mt-2">
          <!-- Add Textbox Button -->
          <button class="btn add-text-btn w-100 me-3" (click)="addTextbox()">
            <div class="d-flex align-items-center">
              <h1 class="m-0 me-2">
                <i class="bi bi-fonts"></i>
              </h1>

              <p class="mb-0">เพิ่มข้อความ</p>
            </div>
          </button>
          <button class="btn add-text-btn w-100" (click)="addImage()">
            <div class="d-flex align-items-center">
              <h1 class="m-0 me-2">
                <i class="bi bi-image"></i>
              </h1>
              <p class="mb-0">เพิ่มรูปภาพ</p>
            </div>
          </button>
          <input type="file" name="" accept="image/png, image/jpeg, image/jpg" hidden #imagePrintMapsUpload
            (change)="onImageUpload($event)" />
        </div>
        <div>
          <h3 class="my-2">รูปแบบการบันทึก</h3>

          <div class="d-flex justify-content-between">
            <input type="radio" class="btn-check" id="saveType1" name="saveType" [(ngModel)]="data.saveType" value="pdf"
              autocomplete="off" checked />
            <label class="btn btn-print-custom w-100 me-2" for="saveType1">.pdf</label>

            <input type="radio" class="btn-check" id="saveType2" name="saveType" [(ngModel)]="data.saveType"
              value="jpeg" autocomplete="off" />
            <label class="btn btn-print-custom w-100 me-2" for="saveType2">.jpeg</label>

            <input type="radio" class="btn-check" id="saveType3" name="saveType" [(ngModel)]="data.saveType" value="png"
              autocomplete="off" />
            <label class="btn btn-print-custom w-100 me-2" for="saveType3">.png</label>

            <input type="radio" class="btn-check" id="saveType4" name="saveType" [(ngModel)]="data.saveType"
              value="tiff" autocomplete="off" />
            <label class="btn btn-print-custom w-100" for="saveType4">.tiff</label>
          </div>
        </div>

        <div class="my-3">
          <!-- <a (click)="printMaps()" class="btn btn-success w-100 text-white"
            >บันทึกภาพแผนที่</a
          > -->

          <a (click)="saveAsImage()" class="btn btn-success w-100 text-white mb-2">บันทึกภาพแผนที่</a>
        </div>
      </div>
    </div>

  </div>

  <div id="context-menu" class="context-menu">
    <ul>
      <li [ngClass]="{ 'd-none': selectedElementType == 'image' }">
        <div>ขนาด:</div>
        <input type="number" id="font-size-input" min="8" max="100" (change)="changeFontSize($event)" />
      </li>
      <li [ngClass]="{ 'd-none': selectedElementType == 'image' }">
        <div class="d-flex justify-content-between">
          <div>สีตัวอักษร:</div>
        </div>
        <div>
          <input id="font-color-input" [(colorPicker)]="textColor" [style.background]="textColor"
            (colorPickerChange)="changeFontColor($event)" />
        </div>
      </li>
      <li [ngClass]="{ 'd-none': selectedElementType == 'image' }">
        <div class="d-flex justify-content-between">
          <div>สีพื้นหลัง:</div>
        </div>
        <div>
          <input id="bg-color-input" [(colorPicker)]="bgColor" [style.background]="bgColor"
            (colorPickerChange)="changeBackgroundColor($event)" />
        </div>
      </li>
      <li [ngClass]="{ 'd-none': selectedElementType == 'image' }">
        <div class="d-block">
          <div>รูปแบบ:</div>
          <div class="alignment-buttons">
            <a class="btn" (click)="toggleTextStyle('bold')" title="ตัวหนา">
              <i class="bi bi-type-bold"></i>
            </a>
            <a class="btn" (click)="toggleTextStyle('italic')" title="ตัวเอียง">
              <i class="bi bi-type-italic"></i>
            </a>
            <a class="btn" (click)="toggleTextStyle('underline')" title="ขีดเส้นใต้">
              <i class="bi bi-type-underline"></i>
            </a>
            <a class="btn" (click)="alignText('left')" title="จัดชิดซ้าย">
              <i class="bi bi-text-left"></i>
            </a>
            <a class="btn" (click)="alignText('center')" title="จัดกึ่งกลาง">
              <i class="bi bi-text-center"></i>
            </a>
            <a class="btn" (click)="alignText('right')" title="จัดชิดขวา">
              <i class="bi bi-text-right"></i>
            </a>
          </div>
        </div>
      </li>
      <li [ngClass]="{ 'd-none': selectedElementType == 'textbox','d-block': selectedElementType != 'textbox' }">
        <div>ความโปร่งแสง:</div>
        <div class="d-flex align-item-center justify-content-between" style="margin-top: 0.35rem">
          <input type="range" min="0" max="100" step="1" class="styled-range w-100 me-3" id="opacity-input"
            [(ngModel)]="opacity" (change)="changeOpacity($any($event.target).value)"
            [style.--range-value.%]="opacity" />
          <div style="width: 75px" class="text-end align-item-center">
            {{ opacity | number }} %
          </div>
        </div>
      </li>
      <li (click)="deleteItem()" [ngClass]="{ 'd-none': !selectedElementDeleteAble }" class="text-danger">
        <div><i class="bi bi-trash3 me-2"></i>ลบ</div>
      </li>
      <li (click)="bringImageToFront()" [ngClass]="{ 'd-none': selectedElementType == 'textbox' }">
        <div><i class="bi bi-arrow-bar-up me-2"></i>นำไปข้างหน้า</div>
      </li>
      <li (click)="sendImageToBack()" [ngClass]="{ 'd-none': selectedElementType == 'textbox' }">
        <div><i class="bi bi-arrow-bar-down me-2"></i>นำไปข้างหลัง</div>
      </li>
      <li (click)="bringTextToFront()" [ngClass]="{ 'd-none': selectedElementType == 'image' }">
        <div><i class="bi bi-arrow-bar-up me-2"></i>นำไปข้างหน้า</div>
      </li>
      <li (click)="sendTextToBack()" [ngClass]="{ 'd-none': selectedElementType == 'image' }">
        <div><i class="bi bi-arrow-bar-down me-2"></i>นำไปข้างหลัง</div>
      </li>
      <li (click)="saveElementAsImage()" [ngClass]="{ 'd-none': selectedElementType == 'image' }">
        <div><i class="bi bi-arrow-bar-down me-2"></i>บันทึกเป็นรูปภาพ</div>
      </li>
    </ul>
  </div>
</div>